import { render, staticRenderFns } from "./ViewServices.vue?vue&type=template&id=65346076&scoped=true"
import script from "./ViewServices.vue?vue&type=script&lang=js"
export * from "./ViewServices.vue?vue&type=script&lang=js"
import style0 from "./ViewServices.vue?vue&type=style&index=0&id=65346076&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65346076",
  null
  
)

export default component.exports